// This app's field classes: the shared ones from @optimyl/ui, bound to the brand tone.
//
// Bound here rather than at ~20 call sites, the same way components/Spinner.tsx binds the brand colour.
// @optimyl/ui takes the tone as a required argument so the shared package has no favourite consumer.
import { inputClass as toneInputClass, labelClass as toneLabelClass, type FieldState } from "@optimyl/ui";

export { resolveFieldState, type FieldState } from "@optimyl/ui";

export const inputClass = (state: FieldState = "default"): string => toneInputClass(state, "brand");

export const labelClass = (): string => toneLabelClass("brand");
